export default "__VITE_ASSET__BkA9UnAM__"